import { render, staticRenderFns } from "./RegistGuide.vue?vue&type=template&id=3abb7631&scoped=true&"
import script from "./RegistGuide.vue?vue&type=script&lang=js&"
export * from "./RegistGuide.vue?vue&type=script&lang=js&"
import style0 from "./RegistGuide.vue?vue&type=style&index=0&id=3abb7631&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abb7631",
  null
  
)

export default component.exports